import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 footer-copyright">
              <p className="mb-0" style={{ color: "#484848" }}>
                Copyright 2023 © Powerd by Homele
              </p>
            </div>
            <div className="col-md-6">
              <p className="pull-right mb-0" style={{ color: "#484848" }}>
                Software & Homele<i className="fa fa-heart"></i>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
